import React from 'react';

import { Formik, Form } from 'formik';
import humps from 'humps';

import AADatepicker from 'ActiveAdmin/AADatepicker';
import AACheckbox from 'ActiveAdmin/AACheckbox';
import AATextInput from 'ActiveAdmin/AATextInput';

import PrescriptionMedicinesSubform from "./PrescriptionMedicinesSubform";

import AutoSave from 'AttachmentForm/AutoSave';

// Вывод краткой формы обработки назначения
const AppointmentShortForm = ({ appointmentItem, saveAttachment }) => {
  const { id, meta } = appointmentItem;

  const renderContent = () => (
    <Formik key={id}
            initialValues={humps.camelizeKeys(appointmentItem)}
            onSubmit={saveAttachment}>
      <Form>
        <AutoSave debounceMs={1000} />
        <h4>Назначение №{id}</h4>
        <fieldset className='inputs appointments'>
          <ol>
            <AATextInput label="ИНН ЛПУ" name='treatmentFacilityInn' />
            <AATextInput label="Название ЛПУ" name='treatmentFacilityName' />
            <AATextInput label='Город ЛПУ' name='clinicCity' />

          </ol>

          <ol className='checkboxes_container'>
            <div>
              <AACheckbox name='foreignDocument' label={meta?.region === 'uz' ? 'Покупка/документ вне территории действия полиса' : 'Куплено/выписано за пределами России'} />
              <AACheckbox name='fakeImage' label='Подозрение на мошенничество' />
              <AACheckbox name="sharpImage" label="Фото разборчивое" />
            </div>

            <AADatepicker label='Дата выписки рецепта' name='prescriptionDate' calendarDate={meta?.region === 'uz'} className='text_input' />
          </ol>

          <ol className='checkboxes_container'>
            <div>
              <AACheckbox name='stamped' label='Печать' />
              <AACheckbox name='signed' label='Подпись' />
              <AACheckbox name='matchesTicketFullName'
                          label='ФИО клиента совпадает с тем, что в заявке'
                          hint={meta?.ticket_full_name && `В заявке: ${meta?.ticket_full_name}`} />
            </div>

            <AATextInput label='ФИО врача' name='doctorFullName' />
          </ol>
        </fieldset>
        
        <div className='prescription_medicines_subform'>
          <h4>Назначенные препараты</h4>
          <PrescriptionMedicinesSubform isLabeled={false} />
        </div>
      </Form>
    </Formik>
  );

  return renderContent();
};

export default AppointmentShortForm;
